"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubNavTabs = void 0;

var _react = _interopRequireWildcard(require("react"));

var _theming = require("@storybook/theming");

var _designSystem = require("@storybook/design-system");

var _styles = require("../shared/styles");

var _Menu = require("../Menu");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var Tabs = ( /*#__PURE__*/0, _theming.styled)(_designSystem.LinkTabs, process.env.NODE_ENV === "production" ? {
  target: "ezzwmly1"
} : {
  target: "ezzwmly1",
  label: "Tabs"
})("display:none;@media (min-width: ", _styles.breakpoints[2], "px){display:flex;}");
var TabsMenu = ( /*#__PURE__*/0, _theming.styled)(_Menu.Menu, process.env.NODE_ENV === "production" ? {
  target: "ezzwmly0"
} : {
  target: "ezzwmly0",
  label: "TabsMenu"
})("flex:none;display:inline-flex;margin-top:4px;margin-bottom:4px;@media (min-width: ", _styles.breakpoints[2], "px){display:none;}");

var SubNavTabs = function SubNavTabs(_ref) {
  var label = _ref.label,
      items = _ref.items;
  var activeItem = (0, _react.useMemo)(function () {
    return items.find(function (item) {
      return item.isActive;
    });
  }, [items]);
  var menuItems = (0, _react.useMemo)(function () {
    return items.map(function (item) {
      return {
        label: item.label,
        link: {
          url: item.href,
          linkWrapper: item.LinkWrapper
        }
      };
    });
  }, [items]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Tabs, {
    role: "navigation",
    "aria-label": label,
    items: items
  }), /*#__PURE__*/_react["default"].createElement(TabsMenu, {
    items: menuItems,
    label: activeItem.label
  }));
};

exports.SubNavTabs = SubNavTabs;